<div class="rx-app-flex-container-row" [class.patient-info__row--responsive]="isResponsive">
    <rx-info-block
        class="info-box patient-info__patient"
        [class.patient-info__patient--responsive]="isResponsive"
        [fields]="[{ name: 'PatientSection.Patient', id: 'general-patient-name', value: patient | mapper: getPatientName, isInline: true }]"
    ></rx-info-block>
    <div class="rx-separator vertical transparent" [class.patient-info__separator]="isResponsive"></div>
    <rx-info-block
        class="info-box rx-app-flex"
        [fields]="[{ name: 'GeneralRxData.ChartNumber', id: 'general-chart-number', value: patient?.ChartNumber, isInline: true }]"
    ></rx-info-block>
</div>
